import { render, staticRenderFns } from "./RepairPoi.vue?vue&type=template&id=16809f06&scoped=true"
import script from "./RepairPoi.vue?vue&type=script&lang=js"
export * from "./RepairPoi.vue?vue&type=script&lang=js"
import style0 from "./RepairPoi.vue?vue&type=style&index=0&id=16809f06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16809f06",
  null
  
)

export default component.exports